import {formatDateWithWeekday} from 'presentation/utils/formatDateWithWeekday';

const formatProtocolDate = (date: string, dateOnly?: boolean) => {
	const {weekday, day, monthNumber, year} = formatDateWithWeekday(date.split(' ')[0]);

	if (dateOnly) {
		return `${day}/${monthNumber}/${year} (${weekday})`;
	}

	return `${day}/${monthNumber}/${year} às ${date.split(' ')[1]} (${weekday})`;
};

export {formatProtocolDate};
